import React from 'react';

const JS_2015_ES6 = () => {
  return (
    <div >
      <h1>JS_2015_ES6</h1>
      <p>Placeholder component for: "JS 2015 (ES6)"</p>
    </div>
  );
};

export default JS_2015_ES6;
